import { t } from '@lingui/core/macro';
import type { QueueTaskInfo, QueueTaskState, SimulationState } from '@/types/api';

export const TERMINAL_SIMULATION_STATES: SimulationState[] = ['complete_ok', 'complete_collisions', 'error'];

export const TERMINAL_TASK_STATES: QueueTaskState[] = ['done', 'failed', 'cancelled'];

export interface ProgressMessage {
  label: React.ReactNode;
  percent: number;
}

export const getProgressMessage = (progress: QueueTaskInfo | null): ProgressMessage => {
  const percent = progress?.progress_percent ?? 0;
  const step = progress?.progress_step ?? null;

  let label: React.ReactNode;
  if (step === 'downloading_files') {
    label = t`Downloading files… ${percent}%`;
  } else if (step === 'generating_preview') {
    label = t`Generating preview…`;
  } else if (step === 'simulating_program_file') {
    const filename = progress?.progress_step_data?.filename ?? '';
    label = t`Simulating ${filename}… ${percent}%`;
  } else if (step === 'encoding_video') {
    label = t`Encoding video… ${percent}%`;
  } else {
    label = t`Processing… ${percent}%`;
  }

  return { label, percent };
};
